/*
 * @Description:
 * @Date: 2025-06-10 19:21:04
 */
import { ref } from 'vue';
import { useCloned } from '@vueuse/core';
import { PAY_PASSAGEWAY_MAPPING } from '@constants/bank';
import { actOpenInfo } from '../data-source/apis';
import { Bank, ActOpenInfoData } from '../data-source/types';

export const useBank = () => {
  const { offLineBank, ...PAY_PASSAGEWAY } = useCloned(PAY_PASSAGEWAY_MAPPING)
    .cloned.value;

  const banks = ref<Array<Bank & (typeof PAY_PASSAGEWAY)['fyBank']>>([]);
  const openInfo = ref<ActOpenInfoData>({
    deptId: null,
    entpName: '',
    zbBank: {
      payPassagewayCode: '',
      payPassagewayName: '',
      actOpenStatus: 10,
      platformAuthStatus: 0,
      enabled: 0
    },
    fyBank: {
      payPassagewayCode: '',
      payPassagewayName: '',
      actOpenStatus: 10,
      platformAuthStatus: 0,
      enabled: 0
    }
  });

  const updateBanks = async () => {
    const { data } = await actOpenInfo();
    openInfo.value = data;
    banks.value = Object.values(PAY_PASSAGEWAY).map(item => {
      return {
        ...item,
        /* 默认 */
        actOpenStatus: 10,
        platformAuthStatus: 0,
        enabled: 1,
        /* 覆盖默认 */
        ...data[item.value]
      } as Bank & typeof item;
    });
  };

  return { banks, updateBanks, openInfo };
};
